import {Component, Injector, OnInit} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {Translations} from "@translations";

export interface DialogDataConfirmSkipSessionRunDialogInput extends MatDialogDataBaseInput {}

export interface DialogDataConfirmSkipSessionRunDialogOutput extends MatDialogDataBaseOutput {
	followUpAction: "cancel" | "abort-previous-session-run";
}

@Component({
	selector: "sim-confirm-skip-session-run-dialog",
	templateUrl: "./confirm-skip-session-run-dialog.component.html",
	styleUrls: ["./confirm-skip-session-run-dialog.component.scss"],
	standalone: false,
})
export class ConfirmSkipSessionRunDialogComponent extends BasicMaterialDialog<
	ConfirmSkipSessionRunDialogComponent,
	DialogDataConfirmSkipSessionRunDialogInput,
	DialogDataConfirmSkipSessionRunDialogOutput
> {
	T = Translations;

	constructor(_injector: Injector) {
		super(_injector);
	}

	ngOnInit(): void {}
}
